/* src/app/weighbridge/pages/weighbridge-yard-trade-list/weighbridge-yard-trade-list.component.scss */
/*# sourceMappingURL=weighbridge-yard-trade-list.component.css.map */
